// This file is meant to replace barbaConfig.js wich inited barba and linked different scripts to it.
// Those scripts have been inserted in a different way in this file.


import General from "./general";
import HeroAnim from "./heroAnim";
import References from "../views/_references";
import Reference from "../views/_reference";
import Blog from "../views/_blog";
import Single from "../views/_single";

class BarbaRemoval {
  constructor() {
    BarbaRemoval.setupConfig();
  }

  static setupConfig() {

    document.addEventListener("DOMContentLoaded", () => {
      new HeroAnim();
    });


    window.addEventListener("load", () => {
      // if (typeof ga === "function") {
      //   ga("set", "page", window.location.pathname);
      //   ga("send", "pageview");
      // }

      if (typeof window.HubSpotForms !== "object") return;

      this.GeneralFn = new General();
      // barba.hooks.leave
      window.cursor.leave(true);

      // Barba init, loading by views
      const appContainer = document.querySelector("[data-pjax=container]");

      switch (appContainer.dataset.pjaxNamespace) {
      case "references":
        this.ReferencesFn = new References();
        break;
      case "reference":
        return new Reference();
      case "blog":
        this.BlogFn = new Blog();
        break;
      case "single":
        return new Single();
      default:
        break;
      }


    });
  }

}

export default BarbaRemoval;
